
export default {
  init() {




    //  prevent parallaxing on tablet
  //   if ( $( window ).width() < 1025 ) {
  //     $('.parallax-image').removeClass('parallax-image')
  //     $('.parallax-title').removeClass('parallax-title')
  //   }
  //
  //   // on page resizing prevent parallaxing on tablet
  //   $(window).resize(function() {
  //     if ( $( window ).width() < 1025 ) {
  //       $('.parallax-image').removeClass('parallax-image')
  //       $('.parallax-title').removeClass('parallax-title')
  //     }
  // })
  // if screen size is bigger than tablet then treat banner like desktop

  if ( $(window).width() > 1162 ) {
    $( '.hover-txt' ).on('mouseover', function() {
      $( '.video-overlay' ).addClass('video-bg-expand')
      $( '.fade-txt' ).addClass('video-bg-expanded-opacity-text')
      $( this ).addClass('video-bg-expanded-headline')
      $( "video" ).get(0).play();
    })

    $( '.hover-txt' ).on('mouseleave', function() {
      $( '.video-overlay' ).removeClass('video-bg-expand')
      $( '.fade-txt' ).removeClass('video-bg-expanded-opacity-text')
      $( this ).addClass('video-bg-expanded-headline')
      $( "video" ).get(0).pause();
    })
  }

  $( "video" ).onended = function(e) {
  $(this).get(0).pause();
}


  // if screen size is smaller than desktop then treat banner like tablet
    if ( $(window).width() < 1162 ) {
      $( "video" ).get(0).play();

      $(document).on('scroll', function() {
        $( "video" ).get(0).pause();

        if($(window).scrollTop() === 0) {
          $( "video" ).get(0).play();
        }
      })

    }

  // on page load open up the first accordion item
  if ( $('.active-accordion-item').length > 0 ) {
    $('.active-accordion-item ~ .accordion-item-copy').slideDown();
  }


  // on page load then load up the first accordion item limage
  let imgURL = $('.active-accordion-item').parent().attr('data-image-src');
  $('.accordion-item-img').addClass('active-img');
  $('.accordion-item-img > img').attr('src', `${imgURL}`);


  // when an accordion item is clicked switch accordion slides and images
  $( '.accordion-item' ).on('click', function() {

    // if all accordions are collapsed then use the first one's image as the default
    setTimeout(function(){
    if ( $('.active-accordion-item').length < 1 ) {
      $('.accordion-item-img').removeClass('active-img');
      let imgURL = $('#default').attr('data-image-src');
      $('.accordion-item-img').addClass('active-img');
      }
    }, 10);

      if ( $(this).find('.accordion-item-title').hasClass('active-accordion-item') ) {
        // $('.accordion-item-img > img').attr('src', '');
        $(this).find('.accordion-item-title').removeClass('active-accordion-item')
        $(this).find('.accordion-item-copy').slideUp();
      }
      else {
        $('.accordion-item-title').removeClass( 'active-accordion-item' )
        $( '.accordion-item-copy' ).slideUp()
        $(this).find('.accordion-item-title').addClass('active-accordion-item')
        $(this).find('.accordion-item-copy').slideDown();

        $('.accordion-item-img').removeClass('active-img');

        // when an accordion item is clicked grab it's data attribute and store it in a variable
        let imgURL = $(this).attr('data-image-src');

        // use that varialbe as the src of the image and reload the image
        setTimeout(function(){
            $('.accordion-item-img').addClass('active-img');
            $('.accordion-item-img > img').attr('src', `${imgURL}`);
        }, 1100);
      }





  })





	},
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js